import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'react-router/lib/withRouter';
import OverlaySpinner from '../../../common/OverlaySpinner';
import { branch, compose, lifecycle, renderComponent, withHandlers, withState } from 'recompose';

import * as actions from '../actions';
import { bindActionsForRoles } from '../../../common/helpers/actions';
import { getActiveBarberId, getActiveShopId, getRoleIdType, getShopBrandId } from '../../../auth/selectors';

const fetchServiceOnMount = () => compose(
  withRouter,
  connect(
    state => ({
      roleIdType: getRoleIdType(state),
      brandId: getShopBrandId(state),
      barberId: getActiveBarberId(state),
      shopId: getActiveShopId(state),
    }),
    dispatch => ({
      fetchService: bindActionsForRoles(
        dispatch, actions.fetchShopUserService, actions.fetchBarberUserService, actions.fetchBrandUserService,
      ),
    }),
  ),
  withState('service', 'setService', null),
  withState('isServiceLoading', 'setIsServiceLoading', false),
  withHandlers({
    fetchService: props => () => {
      const { serviceId } = props.params;
      const isEditMode = !!serviceId;

      if (isEditMode) {
        props.setIsServiceLoading(true);

        const ids = {
          serviceId,
          brandId: props.brandId,
          shopId: props.shopId,
          barberId: props.barberId,
        };

        props.setService(null);

        const fetchService = props.fetchService[props.roleIdType.type];

        fetchService(ids)
          .then((service) => {
            props.setService(service);
            props.setIsServiceLoading(false);
          })
          .catch(() => {
            props.setIsServiceLoading(false);
          });
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchService();
    },
  }),
  branch(
    props => props.params.serviceId && !props.service,
    renderComponent(() => <OverlaySpinner showForContainerApp />),
  ),
);

export default fetchServiceOnMount;
